import { Component, Input } from '@angular/core';

@Component({
    selector: 'spv2-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss'],
    standalone: false
})
export class LoadingOverlayComponent {
  @Input() isLoading: boolean = false;
}
